export const HOUR_OF_DAY_REPORT_ID = 'hour-of-day';
